<template>
    <div class="container">
<!--        <legend>Поиск</legend>-->
        <div class="row">
            <div class="col-md-6">
                <form @submit.prevent="searchOrderBySferaNumber">
                    <div class="form-group">
                        <div class="input-group mb-3">
                            <input type="text" class="form-control" placeholder="Поиск по номеру сфера" v-model="sferaNumber" required>
                            <div class="input-group-append">
                                <button class="btn btn-outline-secondary" type="submit">Поиск</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="col-md-6">
                <form @submit.prevent="searchOrderByClientNumber">
                    <div class="form-group">
                        <div class="input-group mb-3">
                            <input type="text" class="form-control" placeholder="Поиск по номеру клиента" v-model="localNumber" required>
                            <div class="input-group-append">
                                <button class="btn btn-outline-secondary" type="submit">Поиск</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import ErrorModal from '@/admin/components/ErrorModal.vue';

const url = `${process.env.VUE_APP_API_HOST}admin/order`;

export default {
  data() {
    return {
      sferaNumber: '',
      localNumber: '',
    };
  },
  methods: {
    async searchOrderBySferaNumber() {
      if (!this.sferaNumber) {
        return;
      }
      const { data } = await axios.get(`${url}/last-order-by-sferanumber/${this.sferaNumber}`);
      this.searchHandler(data);
    },
    async searchOrderByClientNumber() {
      if (!this.localNumber) {
        return;
      }
      const { data } = await axios.get(`${url}/last-order-by-localnumber/${this.localNumber}`);
      this.searchHandler(data);
    },
    searchHandler(data) {
      if (!data) {
        this.$modal.show(ErrorModal, {
          errors: ['Заказ не найден'] || [],
        }, {
          pivotY: 0.2,
        });
        return;
      }
      console.log(data)
      this.$router.push({ name: 'order-info', params: { orderId: data } });
      this.sferaNumber = '';
      this.localNumber = '';
    },
  },
};
</script>
